import { useDrag } from 'react-dnd';
import onlCamImg from "../../../images/onl-cam.svg";
import offlCamImg from "../../../images/offl-cam.svg";
import unplacedCamImg from "../../../images/unplaced_cam.svg";


const DraggableCamera = ({cameraObj, index, placedCamera}) => {
    // For dragging purpose
    const [, dragRef] = useDrag({
        type: 'CAMERA',
        item: { ...cameraObj }, // cameraObj is sent during dragging process
        canDrag: !placedCamera?.placed, // allow dragging when camera is not placed
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
      });

    return (
        <div className="camera-details-container" key={cameraObj.camera_id}
            style={{borderColor: placedCamera?.placed ? (cameraObj.camera_status ? '#2cc853' : '#f33456') : 'rgba(255, 255, 255, 0.08)',
                    color: !placedCamera?.placed && '#9aa3aa' ,
            }}
            ref={dragRef}
        >
            <div className="camera-container">
                <img 
                    src={
                    (cameraObj.camera_status === 1 ? (placedCamera?.placed ? onlCamImg : unplacedCamImg) : (placedCamera?.placed ? offlCamImg : unplacedCamImg))
                    } 
                    alt="cam-img"
                    className='cam-img'>    
                </img>
            </div>
            <div className="camera-details">
                <span className="camera-number">{cameraObj.camera_name}</span>
                {/* <p><b>ID</b>: {cameraObj.camera_id}</p> */}
                <p><b>Server</b>: {cameraObj.server_name}</p>
                {/* {placedCamera ?
                <p style={{fontWeight: 300}}>Position: ({placedCamera?.x}, {placedCamera?.y})</p>
                :
                <p>Position: (0,0)</p>
                } */}
            </div>
            <div className="camera-placed">
                {/* Status */}
                <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: cameraObj.camera_status === 1 ? '#39ff14' : 'red',
                    boxShadow: '0 0 0 3px rgba(39, 174, 96, 0.2)'}}
                >
                </div>
            </div>
        </div>
    );
}

export default DraggableCamera;